// extracted by mini-css-extract-plugin
export default {"button":"button_button__HzWwD","contained":"button_contained__IUKX2","transparent":"button_transparent__GYoPI"};